import { chatgptRepository } from './repository';
import ChatGPTServiceImpl from './service/ChatGPTServiceImpl';

const chatGPTService = new ChatGPTServiceImpl(chatgptRepository);

export { chatGPTService };
